import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import DemsView from './view/DemsView';
import DemsDetails from './details/DemsDetails';
import DemsDetailsRightSidebar from './details/DemsDetailsRightSidebar';

import buttons from './DemsButtons';
import events from './DemsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));
const DemsMessagesPreview = lazyRetry(() => import('./dems-messages/DemsMessagesPreview'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('dems'),
	routes: [
		{
			settings: {
				layout: {
					style: 'layout1',
					config: {
						mode: 'contained',
						navbar: { display: false },
						toolbar: { display: false },
						footer: { display: false },
						leftSidePanel: { display: false },
						rightSidePanel: { display: false }
					}
				}
			},
			path: 'dems/message/:id/preview',
			element: <DemsMessagesPreview key="dems/message" />
		},
		{
			path: 'dems/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'dems'),
			element: (
				<DetailsPage
					key="dems/add"
					module="dems"
					tabs={DemsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'dems/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'dems'),
			element: (
				<DetailsPage
					key="dems/details"
					module="dems"
					tabs={DemsDetails}
					buttons={buttons.details}
					events={events}
					getRightSidebarSections={DemsDetailsRightSidebar}
				/>
			)
		},
		{
			path: 'dems/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'dems'),
			element: (
				<ViewPage
					key="dems/view"
					module="dems"
					content={{ type: 'tabs', tabs: DemsView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
